import { useState } from "react";
import { api } from "../api";
import { useAuth } from "../auth-context";

export function TeamsPage() {
  const { profile, refresh } = useAuth();
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [strictness, setStrictness] = useState(0);
  const [busy, setBusy] = useState(false);

  async function create() {
    if (!name) return;
    setBusy(true);
    try {
      await api.createTeam({ name, description: desc, strictnessBoost: strictness });
      await refresh();
      setName(""); setDesc(""); setStrictness(0);
    } finally { setBusy(false); }
  }

  return (
    <>
      <header className="sg-page-header">
        <div>
          <h1 className="sg-page-title">Teams</h1>
          <div className="sg-page-sub">Group Users · Apply Scoped Policies</div>
        </div>
      </header>

      <div className="sg-grid sg-grid-2">
        <div className="sg-panel">
          <div className="sg-panel-head"><div className="sg-panel-title">Teams ({profile.teams.length})</div></div>
          <div className="sg-panel-pad sg-stack">
            {profile.teams.map((t: any) => (
              <div key={t.id} className="sg-card" style={{ gridTemplateColumns: "1fr auto" }}>
                <div className="sg-card-body">
                  <div className="sg-card-title">{t.name}</div>
                  <div className="sg-muted" style={{ fontSize: 12 }}>
                    {t.description || "No description."} · strictness {t.strictnessBoost}
                  </div>
                </div>
                <div className="sg-muted" style={{ fontSize: 12 }}>
                  {t.allowedDomains.join(", ")}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="sg-panel">
          <div className="sg-panel-head"><div className="sg-panel-title">New Team</div></div>
          <div className="sg-panel-pad">
            <div className="sg-field">
              <label className="sg-label">Team Name</label>
              <input className="sg-input" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="sg-field">
              <label className="sg-label">Description</label>
              <input className="sg-input" value={desc} onChange={(e) => setDesc(e.target.value)} />
            </div>
            <div className="sg-field">
              <label className="sg-label">Strictness Boost (-1 to +2)</label>
              <input
                className="sg-input"
                type="number"
                min={-1} max={2}
                value={strictness}
                onChange={(e) => setStrictness(parseInt(e.target.value, 10) || 0)}
              />
            </div>
            <button className="sg-btn sg-btn-primary" onClick={create} disabled={busy || !name}>
              {busy ? "Creating…" : "Create Team"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
